'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHammerjs = require('react-hammerjs');

var _reactHammerjs2 = _interopRequireDefault(_reactHammerjs);

var _reactMeasure = require('react-measure');

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _reactTimeout = require('react-timeout');

var _reactTimeout2 = _interopRequireDefault(_reactTimeout);

var _sign = require('./utils/sign');

var _createTimeConversion = require('./createTimeConversion');

var _createTimeConversion2 = _interopRequireDefault(_createTimeConversion);

var _createNumberConversion = require('./createNumberConversion');

var _createNumberConversion2 = _interopRequireDefault(_createNumberConversion);

var _ViewerItem = require('./ViewerItem');

var _constants = require('./constants');

require('./Viewer.css');

var _useReversedNumbers = require('./utils/useReversedNumbers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SMOOTH_SCROLL_ACCELERATION = -0.001; // px/ms^2
var SMOOTH_SCROLL_MAX_TIME = 5000; // milliseconds
var ZOOM_FACTOR = 0.7;

var Viewer = function (_PureComponent) {
  _inherits(Viewer, _PureComponent);

  function Viewer() {
    var _temp, _this, _ret;

    _classCallCheck(this, Viewer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.initialized = false, _this.panState = {}, _this.smoothScrollAnimationFrame = null, _this.yConversion = null, _this.xConversion = null, _this.viewerBounds = null, _this.yOutOfBoundsPosition = null, _this.yDistanceFromOriginalPoint = null, _this.yDistanceFromTop = null, _this.yMouseOutOfScreenInterval = null, _this.xOutOfBoundsPosition = null, _this.xDistanceFromOriginalPoint = null, _this.xDistanceFromLeft = null, _this.xMouseOutOfScreenInterval = null, _this.xItemDelta = null, _this.yItemDelta = null, _this.yCreateConversion = function () {
      if (_this.props.yType === 'Date') {
        return (0, _createTimeConversion2.default)(_this.props.yStart, _this.props.yEnd, _this.props.height, _this.props.yMargin);
      }

      if (_this.props.yType === 'Number') {
        return (0, _createNumberConversion2.default)(_this.props.yStart, _this.props.yEnd, _this.props.height, _this.props.yMargin);
      }

      return null;
    }, _this.xCreateConversion = function () {
      if (_this.props.xType === 'Date') {
        return (0, _createTimeConversion2.default)(_this.props.xStart, _this.props.xEnd, _this.props.width, _this.props.xMargin);
      }

      if (_this.props.xType === 'Number') {
        return (0, _createNumberConversion2.default)(_this.props.xStart, _this.calculateEndNumber(_this.props.xStart, _this.props.xEnd, _this.props.width, _this.props.xMargin), _this.props.width, _this.props.xMargin);
      }

      return null;
    }, _this.handleResize = function (contentRect) {
      _this.initialized = true;
      _this.viewerBounds = contentRect.bounds;
      _this.resetOutOfBoundsCoordinates();
      _this.props.onResize(contentRect.bounds);
    }, _this.handleTouchStart = function (event) {
      // prevents the touch of the event to be initiated by the middle / right mouse buttons
      if (event.button && (event.button === 1 || event.button === 2)) {
        return;
      }

      cancelAnimationFrame(_this.smoothScrollAnimationFrame);

      // copy the current state, will be used whilst dragging
      var panProps = {
        calculatedEndNumber: _this.calculateEndNumber(_this.props.xStart, _this.props.xEnd, _this.props.width, _this.props.xMargin)
      };
      var draggedItemProps = getDraggedItemProps(event);
      _this.panState = Object.assign(panProps, draggedItemProps, _this.props);
    }, _this.handlePan = function (event) {
      event.preventDefault();

      // If it's the first time the user starts dragging set panned to true
      if (!_this.panState.panned) {
        _this.panState.panned = true;
      }

      if (_this.panState.item) {
        _this.xItemDelta = event.deltaX;
        _this.yItemDelta = event.deltaY;

        // User is moving a item out of the viewer, to the top
        if (_this.props.onYChange && _this.viewerBounds.top > event.center.y) {
          var distance = _this.viewerBounds.top - event.center.y;
          _this.ySetDistanceOffScreen(distance, event.deltaY);

          if (!_this.yMouseOutOfScreenInterval) {
            _this.yMouseOutOfScreenInterval = _this.props.setInterval(_this.yMoveOutOfScreenInterval, 20);
          }

          // User is moving a item out of the viewer, to the bottom
        } else if (_this.props.onYChange && _this.viewerBounds.top + _this.viewerBounds.height < event.center.y) {
          var _distance = _this.viewerBounds.top + _this.viewerBounds.height - event.center.y;
          _this.ySetDistanceOffScreen(_distance, event.deltaY);

          if (!_this.yMouseOutOfScreenInterval) {
            _this.yMouseOutOfScreenInterval = _this.props.setInterval(_this.yMoveOutOfScreenInterval, 20);
          }

          // User is moving a item out of the viewer, to the left
        } else if (_this.props.onXChange && _this.viewerBounds.left > event.center.x) {
          var _distance2 = _this.viewerBounds.left - event.center.x;
          _this.xSetDistanceOffScreen(_distance2, event.deltaX);

          if (!_this.xMouseOutOfScreenInterval) {
            _this.xMouseOutOfScreenInterval = _this.props.setInterval(_this.xMoveOutOfScreenInterval, 20);
          }

          // User is moving a item out of the viewer, to the right
        } else if (_this.props.onXChange && _this.viewerBounds.left + _this.viewerBounds.width < event.center.x) {
          var _distance3 = _this.viewerBounds.left + _this.viewerBounds.width - event.center.x;
          _this.xSetDistanceOffScreen(_distance3, event.deltaX);

          if (!_this.xMouseOutOfScreenInterval) {
            _this.xMouseOutOfScreenInterval = _this.props.setInterval(_this.xMoveOutOfScreenInterval, 20);
          }

          // User is moving the item within the view
        } else {
          _this.resetTheOutOfScreenInterval();

          var deltaY = _this.yDistanceFromOriginalPoint ? event.deltaY + _this.yDistanceFromOriginalPoint : event.deltaY;
          var deltaX = _this.xDistanceFromOriginalPoint ? event.deltaX + _this.xDistanceFromOriginalPoint : event.deltaX;

          _this.moveItem(_this.panState.item, _this.panState.movement, _this.panState.onChange, _this.panState.draggedArea, deltaX, deltaY);
        }
      } else {
        if (_this.props.disablePanScroll !== true) {
          _this.move(event.deltaX, event.deltaY);
        }
      }

      if (_this.panState.item || _this.props.disablePanScroll !== true) {
        _this.panState.moveTimeStampPrev = _this.panState.moveTimeStamp;
        _this.panState.moveTimeStamp = event.timeStamp;
      }
    }, _this.handlePanEnd = function (event) {
      // The user has stopped dragging a item
      if (_this.panState.item) {
        if (_this.props.onDraggingCompleted) {
          _this.props.onDraggingCompleted();
        }
        _this.resetOutOfBoundsCoordinates();
        _this.resetTheOutOfScreenInterval();

        // so remove the item from the panstate
        _this.panState.item = null;
      } else if (_this.props.smoothScroll !== false) {
        // do smooth scrolling when the property is true or undefined
        _this.handleSmoothScroll(event);
      }
    }, _this.handlePressUp = function (event) {
      // The user has stopped pressing a item
      if (_this.panState.item) {
        _this.panState.item = null;
        _this.resetOutOfBoundsCoordinates();
      }
    }, _this.handleRootRef = function (element) {
      if (element) {
        // prevent ghost click after dragging a clickable element
        // important is to use useCapture=true, so we catch the event before
        // it bubbles to the child element that fired the event.
        element.addEventListener('click', _this.handleGhostClick, true);
      }
    }, _this.handleGhostClick = function (event) {
      if (_this.panState.panned) {
        event.preventDefault();
        event.stopPropagation();

        // The user has stopped panning, set it to false here
        _this.panState.panned = false;
      } else {
        // The user really clicked, so the move the item he has clicked on
        _this.panState.item = null;
      }
    }, _this.handleSmoothScroll = function (event) {
      var deltaX = event.deltaX;
      var deltaY = event.deltaY;
      var initialTime = event.timeStamp;
      var delay = initialTime - (_this.panState.moveTimeStampPrev || 0); // ms
      var velocityX = event.overallVelocityX * Math.pow(0.95, delay); // px/ms
      var velocityY = event.overallVelocityY * Math.pow(0.95, delay); // px/ms
      var accelerationX = (0, _sign.sign)(velocityX) * SMOOTH_SCROLL_ACCELERATION; // px/ms^2
      var accelerationY = (0, _sign.sign)(velocityY) * SMOOTH_SCROLL_ACCELERATION; // px/ms^2
      var maxTimeX = Math.min(-velocityX / accelerationX, SMOOTH_SCROLL_MAX_TIME);
      var maxTimeY = Math.min(-velocityY / accelerationY, SMOOTH_SCROLL_MAX_TIME);

      var smoothScroll = function smoothScroll() {
        var time = Date.now() - initialTime;

        if (time < maxTimeX || time < maxTimeY) {
          var timeX = Math.min(time, maxTimeX);
          var timeY = Math.min(time, maxTimeY);
          var distanceX = velocityX * timeX + 0.5 * accelerationX * timeX * timeX;
          var distanceY = velocityY * timeY + 0.5 * accelerationY * timeY * timeY;

          _this.move(deltaX + distanceX, deltaY + distanceY);

          _this.smoothScrollAnimationFrame = requestAnimationFrame(smoothScroll);
        }
      };

      _this.smoothScrollAnimationFrame = requestAnimationFrame(smoothScroll);
    }, _this.handleWheel = function (event) {
      // Only handle scroll if the y axis is allowed to be changed
      if (_this.props.onYChange || _this.props.onXChange) {
        event.preventDefault();

        cancelAnimationFrame(_this.smoothScrollAnimationFrame);

        var panProps = {
          calculatedEndNumber: _this.calculateEndNumber(_this.props.xStart, _this.props.xEnd, _this.props.width, _this.props.xMargin)
        };
        _this.panState = _extends({}, _this.panState, panProps, _this.props);

        // if it's firefox, make the scroll speed feel more natural
        var scrollDeltaY = event.deltaMode === 1 ? event.deltaY * 5 : event.deltaY;
        var scrollDeltaX = event.deltaMode === 1 ? event.deltaX * 5 : event.deltaX;

        if (_this.panState.item) {
          if (_this.props.onYChange) {
            _this.yDistanceFromOriginalPoint += scrollDeltaY;
          }

          if (_this.props.onXChange) {
            _this.xDistanceFromOriginalPoint += scrollDeltaX;
          }

          // Move the item along
          _this.moveItem(_this.panState.item, _this.panState.movement, _this.panState.onChange, _this.panState.draggedArea, _this.xDistanceFromOriginalPoint + _this.xItemDelta, _this.yDistanceFromOriginalPoint + _this.yItemDelta);
        }

        if (_this.panState.item || !_this.panState.panned) {
          if (event.ctrlKey) {
            // zoom
            _this.zoom(-scrollDeltaX, -scrollDeltaY, event.pageX, event.pageY);
          } else {
            // move
            _this.move(-scrollDeltaX, -scrollDeltaY);
          }
        }
      }
    }, _this.yMoveOutOfScreenInterval = function () {
      // Move the timeline
      var yStartContainer = _this.yMove(_this.props.yStart, -_this.yOutOfBoundsPosition);
      var yEndContainer = _this.yMove(_this.props.yEnd, -_this.yOutOfBoundsPosition);

      _this.props.onYChange(yStartContainer, yEndContainer);

      // Calculate how the window has moved
      _this.yDistanceFromOriginalPoint += -_this.yOutOfBoundsPosition;

      // Move the item
      _this.moveItem(_this.panState.item, _this.panState.movement, _this.panState.onChange, _this.panState.draggedArea, _this.xItemDelta, _this.yDistanceFromOriginalPoint + _this.yDistanceFromTop);
    }, _this.xMoveOutOfScreenInterval = function () {
      // Move the timeline
      var xStartContainer = _this.xMove(_this.props.xStart, -_this.xOutOfBoundsPosition);
      var xEndContainer = _this.xMove(_this.props.xEnd, -_this.xOutOfBoundsPosition);

      _this.props.onXChange(xStartContainer, xEndContainer);

      // Calculate how the window has moved
      _this.xDistanceFromOriginalPoint += -_this.xOutOfBoundsPosition;

      // Move the item
      _this.moveItem(_this.panState.item, _this.panState.movement, _this.panState.onChange, _this.panState.draggedArea, _this.xDistanceFromOriginalPoint + _this.xDistanceFromLeft, _this.yItemDelta);
    }, _this.ySetDistanceOffScreen = function (distance, deltaY) {
      _this.yOutOfBoundsPosition = distance;
      _this.yDistanceFromTop = deltaY + distance;
    }, _this.xSetDistanceOffScreen = function (distance, deltaX) {
      _this.xOutOfBoundsPosition = distance;
      _this.xDistanceFromLeft = deltaX + distance;
    }, _this.resetOutOfBoundsCoordinates = function () {
      // Reset Y
      _this.yOutOfBoundsPosition = null;
      _this.yDistanceFromOriginalPoint = null;
      _this.yDistanceFromTop = null;

      // Reset X
      _this.xOutOfBoundsPosition = null;
      _this.xDistanceFromOriginalPoint = null;
      _this.xDistanceFromLeft = null;

      _this.xItemDelta = null;
      _this.yItemDelta = null;
    }, _this.resetTheOutOfScreenInterval = function () {
      _this.props.clearInterval(_this.yMouseOutOfScreenInterval);
      _this.props.clearInterval(_this.xMouseOutOfScreenInterval);
      _this.yMouseOutOfScreenInterval = null;
      _this.xMouseOutOfScreenInterval = null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // Viewer must render once before it can determine it's dimensions
  // until rendered the first time, the contents will be hidden to prevent
  // flickering contents being displayed for a spit second
  // contains a copy of the props whilst panning


  // Used to set the correct position when scrolling and moving


  Viewer.prototype.componentWillUnmount = function componentWillUnmount() {
    cancelAnimationFrame(this.smoothScrollAnimationFrame);
  };

  Viewer.prototype.render = function render() {
    var _this2 = this;

    this.yConversion = this.yCreateConversion();

    this.xConversion = this.xCreateConversion();

    return _react2.default.createElement(
      'div',
      { className: 'viewer-root', ref: this.handleRootRef },
      _react2.default.createElement(
        _reactHammerjs2.default,
        {
          onPan: this.handlePan,
          onPanEnd: this.handlePanEnd,
          onPressUp: this.handlePressUp,
          direction: 'DIRECTION_ALL'
        },
        _react2.default.createElement(
          'div',
          {
            className: 'viewer-contents',
            style: !this.initialized ? { visibility: 'hidden' } : null,
            onWheel: this.handleWheel,
            onTouchStart: this.handleTouchStart,
            onMouseDown: this.handleTouchStart
          },
          _react2.default.createElement(
            _reactMeasure2.default,
            { bounds: true, onResize: this.handleResize },
            function (_ref) {
              var measureRef = _ref.measureRef;
              return _this2.props.children({
                measureRef: measureRef,
                yUnitToScreen: _this2.yConversion.unitToScreen,
                yScreenToUnit: _this2.yConversion.screenToUnit,
                xUnitToScreen: _this2.xConversion.unitToScreen,
                xScreenToUnit: _this2.xConversion.screenToUnit
              });
            }
          )
        )
      )
    );
  };

  Viewer.prototype.calculateEndNumber = function calculateEndNumber(start, end, size, numberMargin) {
    if (typeof this.props.numberScale === 'number') {
      return (0, _useReversedNumbers.useReversedNumbers)(start, end) ? start - (size - 2 * numberMargin) / this.props.numberScale : start + (size - 2 * numberMargin) / this.props.numberScale;
    } else {
      return end;
    }
  };

  Viewer.prototype.zoom = function zoom(deltaXScreen, deltaYScreen, mouseX, mouseY) {
    if (deltaYScreen !== 0 && this.props.onYChange) {
      var zoomFactor = deltaYScreen > 0 ? ZOOM_FACTOR // zoom in
      : 1 / ZOOM_FACTOR; // zoom out

      var y = mouseY - this.viewerBounds.top;
      var height = this.viewerBounds.bottom - this.viewerBounds.top;
      var fraction = y / height;
      if (fraction < 0 || fraction > 1 || isNaN(fraction) || !isFinite(fraction)) {
        fraction = 0.5;
      }

      var newYStart = this.yConversion.screenToUnit(y - height * zoomFactor * fraction);
      var newYEnd = this.yConversion.screenToUnit(y + height * zoomFactor * (1 - fraction));

      this.props.onYChange(newYStart, newYEnd);
    }

    // if (deltaXScreen !== 0 && this.props.onXChange) {
    //   TODO: implement zoom horizontally with ctrl+scroll or an other key combination
    // }
  };

  Viewer.prototype.move = function move(deltaXScreen, deltaYScreen) {
    if (deltaYScreen && !isNaN(deltaYScreen) && deltaYScreen !== 0 && this.props.onYChange) {
      var newYStart = this.yMove(this.panState.yStart, -deltaYScreen);
      var newYEnd = this.yMove(this.panState.yEnd, -deltaYScreen);
      this.props.onYChange(newYStart, newYEnd);
    }

    if (deltaXScreen && !isNaN(deltaXScreen) && deltaXScreen !== 0 && this.props.onXChange) {
      var newXStart = this.xMove(this.panState.xStart, -deltaXScreen);
      var newXEnd = this.xMove(this.panState.calculatedEndNumber, -deltaXScreen);
      this.panState.onXChange(newXStart, newXEnd);
    }
  };

  Viewer.prototype.moveItem = function moveItem(item) {
    var movement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.MOVE_ALL;
    var onChange = arguments[2];
    var draggedArea = arguments[3];
    var deltaXScreen = arguments[4];
    var deltaYScreen = arguments[5];

    if (item && onChange && (deltaXScreen !== 0 || deltaYScreen !== 0)) {
      // figure out what the item is allowed to do
      var canMoveCenter = (movement & _constants.MOVE_CENTER) !== 0;
      var canMoveHorizontal = canMoveCenter || (movement & _constants.MOVE_HORIZONTAL) === _constants.MOVE_HORIZONTAL;
      var canMoveVertical = canMoveCenter || (movement & _constants.MOVE_VERTICAL) === _constants.MOVE_VERTICAL;

      var canMoveLeft = draggedArea === 'center' ? canMoveHorizontal : draggedArea === 'left' && (movement & _constants.MOVE_LEFT) !== 0;

      var canMoveRight = draggedArea === 'center' ? canMoveHorizontal : draggedArea === 'right' && (movement & _constants.MOVE_RIGHT) !== 0;

      var canMoveTop = draggedArea === 'center' ? canMoveVertical : draggedArea === 'top' && (movement & _constants.MOVE_TOP) !== 0;

      var canMoveBottom = draggedArea === 'center' ? canMoveVertical : draggedArea === 'bottom' && (movement & _constants.MOVE_BOTTOM) !== 0;

      // reverseNumbers is needed when the xStart of the item
      // is rendered at the right side of the item and the xEnd on the left
      var reverseNumbers = (0, _useReversedNumbers.useReversedNumbers)(this.props.xStart, this.props.xEnd) ? !(0, _useReversedNumbers.useReversedNumbers)(item.xStart, item.xEnd) : (0, _useReversedNumbers.useReversedNumbers)(item.xStart, item.xEnd);

      // apply changes
      var yStart = canMoveTop ? this.yMove(item.yStart, deltaYScreen) : item.yStart;

      var yEnd = canMoveBottom ? this.yMove(item.yEnd, deltaYScreen) : item.yEnd;

      var xStart = !reverseNumbers && canMoveLeft || reverseNumbers && canMoveRight ? this.xMove(item.xStart, deltaXScreen) : item.xStart;

      var xEnd = !reverseNumbers && canMoveRight || reverseNumbers && canMoveLeft ? this.xMove(item.xEnd, deltaXScreen) : item.xEnd;

      var updatedItem = Object.assign({}, item, {
        yStart: yStart,
        yEnd: yEnd,
        xStart: xStart,
        xEnd: xEnd
      });

      onChange({
        initialItem: this.panState.item,
        updatedItem: updatedItem,
        draggedArea: draggedArea,
        deltaXScreen: deltaXScreen,
        deltaYScreen: deltaYScreen,
        deltaX: this.yMove(0, deltaXScreen),
        deltaY: this.xMove(0, deltaYScreen).valueOf()
      });
    }
  };

  Viewer.prototype.yMove = function yMove(unit, deltaYScreen) {
    return this.yConversion.screenToUnit(this.yConversion.unitToScreen(unit) + deltaYScreen);
  };

  Viewer.prototype.xMove = function xMove(unit, deltaXScreen) {
    return this.xConversion.screenToUnit(this.xConversion.unitToScreen(unit) + deltaXScreen);
  };

  return Viewer;
}(_react.PureComponent);

/**
 * Get the initial properties of a dragged item
 * @param {Event} event
 * @returns {Object | null}
 */


Viewer.propTypes = {
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,
  onResize: _propTypes2.default.func.isRequired,

  yStart: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.instanceOf(Date)]).isRequired,
  yEnd: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.instanceOf(Date)]).isRequired,
  yType: _propTypes2.default.oneOf(['Date', 'Number']).isRequired,
  onYChange: _propTypes2.default.func,
  yMargin: _propTypes2.default.number,

  xStart: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.instanceOf(Date)]).isRequired,
  xEnd: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.instanceOf(Date)]).isRequired,
  xType: _propTypes2.default.oneOf(['Date', 'Number']).isRequired,
  onXChange: _propTypes2.default.func,
  xMargin: _propTypes2.default.number,

  numberScale: _propTypes2.default.number,
  smoothScroll: _propTypes2.default.bool,

  disablePanScroll: _propTypes2.default.bool,

  onDraggingCompleted: _propTypes2.default.func };
function getDraggedItemProps(event) {
  var viewerItem = (0, _ViewerItem.findViewerItem)(event.target);

  if (viewerItem && viewerItem.props.movement !== _constants.MOVE_NONE) {
    return {
      item: viewerItem.props.item,
      movement: viewerItem.props.movement,
      draggedArea: (0, _ViewerItem.findViewerItemArea)(event.target),
      onChange: viewerItem.props.onChange
    };
  } else {
    return null;
  }
}

exports.default = (0, _reactTimeout2.default)(Viewer);